import BaseInputNumber from 'components/atoms/base-input-number';
import { t } from 'i18next';

import s from './styles.module.scss';
import { useFilter } from './filter/use-filter';

import type { FC } from 'react';

type Props = {
  potentialPatientsCount?: number;
};

export const PatientsToTransfer: FC<Props> = (props) => {
  const { potentialPatientsCount } = props;
  const { filter, updateFilter } = useFilter();
  const selectedMoreThanPotential =
    (filter.patientsCountToTransfer ?? 0) > (potentialPatientsCount ?? 0);
  return (
    <div className={s['form-group']}>
      <label>
        <span>{t('labels.enterNumberOfPatientsToTransfer')}</span>
      </label>
      <BaseInputNumber
        value={filter.patientsCountToTransfer}
        onChange={(v) => {
          updateFilter({ patientsCountToTransfer: v ?? 0 });
        }}
      />
      {selectedMoreThanPotential && (
        <span className={s['error-message']}>
          {t('validation.selectedMoreThanAvailablePatients')}
        </span>
      )}
    </div>
  );
};
